import { Slider } from '@mui/material'
import { useState } from 'react'
import styles from './priceRangeStyle.module.scss'

const MIN = 0
const MAX = 500000

const PriceRange = ({ userDetails, setUserDetails }) => {
	const [inputValues, setInputValues] = useState({
		lower: '',
		upper: '',
	})

	const handleInputChange = (e, bound) => {
		const rawValue = e.target.value.replace(/[^0-9]/g, '')

		if (bound === 'lowerPriceRange') {
			setInputValues({ ...inputValues, lower: rawValue })
		} else {
			setInputValues({ ...inputValues, upper: rawValue })
		}
	}

	const handleInputBlur = (bound) => {
		const rawValue =
			bound === 'lowerPriceRange' ? inputValues.lower : inputValues.upper

		setInputValues({ lower: '', upper: '' })

		if (rawValue === '') {
			return
		}

		const value = parseInt(rawValue, 10)

		const clampedValue = Math.min(Math.max(value, MIN), MAX)

		setUserDetails({
			...userDetails,
			[bound]: clampedValue,
		})
	}

	const handleInputFocus = (e) => {
		e.target.select()
	}

	const handleSliderChange = (event, newValue) => {
		setUserDetails({
			...userDetails,
			lowerPriceRange: newValue[0],
			upperPriceRange: newValue[1],
		})
	}

	const displayValue = (bound) => {
		if (bound === 'lowerPriceRange') {
			return inputValues.lower !== ''
				? inputValues.lower
				: userDetails.lowerPriceRange || MIN
		} else {
			return inputValues.upper !== ''
				? inputValues.upper
				: userDetails.upperPriceRange || MAX
		}
	}

	return (
		<>
			<div className={styles.priceRange}>
				<input
					onChange={(e) => handleInputChange(e, 'lowerPriceRange')}
					onBlur={() => handleInputBlur('lowerPriceRange')}
					onFocus={handleInputFocus}
					value={`$${displayValue('lowerPriceRange')}`}
					className={styles.input}
				/>
				<span className={styles.middleLine}></span>
				<input
					onChange={(e) => handleInputChange(e, 'upperPriceRange')}
					onBlur={() => handleInputBlur('upperPriceRange')}
					onFocus={handleInputFocus}
					value={`$${displayValue('upperPriceRange')}`}
					className={styles.input}
				/>
			</div>
			<Slider
				value={[
					userDetails.lowerPriceRange || MIN,
					userDetails.upperPriceRange || MAX,
				]}
				onChange={handleSliderChange}
				valueLabelDisplay="auto"
				max={MAX}
				min={MIN}
				sx={{
					color: '#7ca6bd',
					'& .MuiSlider-track': { backgroundColor: '#7ca6bd' },
					'& .MuiSlider-thumb': {
						border: '0.1px solid white',
						width: '12px',
						height: '12px',
					},
					'& .MuiSlider-rail': {
						backgroundColor: '#D6E3EB',
						opacity: 1,
					},
				}}
			/>
		</>
	)
}

export default PriceRange
